import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import type { AssistantAvatarShape } from "@/ui/AssistantAvatar/assistantAvatarConfig";
import { CHARACTER_SHAPE_PATH } from "./characterShapes";

const { FACE } = ASSISTANT_AVATAR;

interface CharacterBodyProps {
	shape: AssistantAvatarShape;
	/** `url(#…)` of the body gradient the figure defines. */
	fill: string;
	/** A jack-o'-lantern: ribs instead of a blush. */
	carved: boolean;
	/** Unique, CSS-safe prefix for this instance's rib clip id. */
	idPrefix: string;
}

/** Pumpkin ribs are the body's own outline narrowed around its middle, so they follow every shape; clipped to the body for wavy hems. */
const RIB_WIDTHS = [0.36, 0.7];
const RIB_STROKE = 3.4;

/** The filled shape plus its highlight and cheeks (or ribs): everything on the body that isn't a feature. */
export const CharacterBody: FC<CharacterBodyProps> = ({ shape, fill, carved, idPrefix }) => (
	<>
		<path d={CHARACTER_SHAPE_PATH[shape]} fill={fill} />
		<ellipse cx={40} cy={34} rx={12} ry={6.5} fill={FACE.SHINE} transform="rotate(-28 40 34)" />
		{carved ? (
			<>
				<clipPath id={`${idPrefix}-ribs`}>
					<path d={CHARACTER_SHAPE_PATH[shape]} />
				</clipPath>
				<g clipPath={`url(#${idPrefix}-ribs)`}>
					{RIB_WIDTHS.map((width) => (
						<path
							key={width}
							d={CHARACTER_SHAPE_PATH[shape]}
							transform={`translate(60 0) scale(${width} 1) translate(-60 0)`}
							fill="none"
							stroke={ASSISTANT_AVATAR.ACCESSORY.PUMPKIN_RIB}
							strokeWidth={RIB_STROKE}
						/>
					))}
				</g>
			</>
		) : (
			<>
				<ellipse cx={34} cy={74} rx={6.5} ry={3.8} fill={FACE.CHEEK_CHARACTER} />
				<ellipse cx={86} cy={74} rx={6.5} ry={3.8} fill={FACE.CHEEK_CHARACTER} />
			</>
		)}
	</>
);
